/* eslint @typescript-eslint/camelcase: "off" */

import { observable, action } from 'mobx';

import {
	getDefaultNetworkStatus,
	getNetworkStatusStarted,
	getNetworkStatusDone,
	getNetworkStatusFailed,
} from '@utils';

import { Api } from '@api';

import { IAlbum, IAlbumShare } from '@interfaces';

import { IAlbumsStoreActionFetchItemShareParams, IAlbumsStoreJSON } from './types';

export class AlbumsStore {

	@observable item: IAlbum;
	@observable itemNetworkStatus = getDefaultNetworkStatus();

	@observable itemShare: IAlbumShare;
	@observable itemShareNetworkStatus = getDefaultNetworkStatus();

	@action async fetchItem(id: string) {
		this.itemNetworkStatus = getNetworkStatusStarted();

		try {
			const response = await Api.albums.fetchAlbum(id);

			this.item = response.data.data.album;

			this.itemNetworkStatus = getNetworkStatusDone();
		} catch (err) {
			this.itemNetworkStatus = getNetworkStatusFailed(err);
		}
	}

	@action async fetchItemShare(id: string, { shareAuth }: IAlbumsStoreActionFetchItemShareParams) {
		this.itemShareNetworkStatus = getNetworkStatusStarted();

		try {
			const response = await Api.albums.fetchAlbumShare(
				id,
				{ share_auth: shareAuth },
			);

			this.itemShare = response.data.data.album;

			this.itemShareNetworkStatus = getNetworkStatusDone();
		} catch (err) {
			this.itemShareNetworkStatus = getNetworkStatusFailed(err);
		}
	}

	toJSON(): IAlbumsStoreJSON {
		return {
			item: this.item,
			itemNetworkStatus: this.itemNetworkStatus,
			itemShare: this.itemShare,
			itemShareNetworkStatus: this.itemShareNetworkStatus,
		};
	}

	fromJSON(data: IAlbumsStoreJSON) {
		this.item = data.item;
		this.itemNetworkStatus = data.itemNetworkStatus;
		this.itemShare = data.itemShare;
		this.itemShareNetworkStatus = data.itemShareNetworkStatus;
	}

}

export const getAlbumsStore = () => new AlbumsStore();
